import { render, staticRenderFns } from "./ContentOnly.vue?vue&type=template&id=de7fc010&scoped=true"
import script from "./ContentOnly.vue?vue&type=script&lang=js"
export * from "./ContentOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7fc010",
  null
  
)

export default component.exports